import angular from 'angular'
import taxClassList from './taxClassListComponent'
import deductionPolicy from './deductionPolicyComponent'
import taxable from './taxableListComponent'
import taxAccount from './taxAccountComponent'
import taxDeclarationCalendar from './taxDeclarationCalendarComponent'

import { taxClass } from 'redevConfig'

const list = (taxClass && taxClass.list) || ''

const taxPolicy = list
  ? require(`redevelopment/system/department/${list.templateName}`)
  : require('./view/taxPolicy.html')

export default angular
  .module('system.basedata.taxClass', [
    taxClassList,
    deductionPolicy,
    taxable,
    taxAccount,
    taxDeclarationCalendar,
  ])
  .config([
    '$stateProvider',
    function config($stateProvider) {
      $stateProvider
        .state('system.basedata.taxClass', {
          abstract: true,
          url: '/taxClass',
          template: '<div ui-view></div>',
          title: '税收政策库',
          default: 'system.basedata.taxClass.list',
        })
        .state('system.basedata.taxClass.list', {
          url: '/list',
          template: taxPolicy,
        })
    },
  ]).name



// WEBPACK FOOTER //
// ./src/app/system/basedata/taxClass/index.js